import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    anyNetworks: 'Any Network',
    anyStatus: 'Any Status',
    active: 'Active',
    paused: 'Paused',
    groupByContract: 'Group by contract',
    search: 'Search...',
    createTask: 'Create Task',
  },
};
